"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiKeysReferenceMap = exports.jsApiKey = void 0;
var JavaScript_1 = require("./JavaScript");
Object.defineProperty(exports, "jsApiKey", { enumerable: true, get: function () { return JavaScript_1.jsApiKey; } });
exports.apiKeysReferenceMap = {
    js: JavaScript_1.jsApiKey,
};
